import useHandleFormCaptcha from "@casino/legacy/client/components/Auth/hooks/useHandleFormCaptcha";
import useRefCode from "@casino/legacy/client/hooks/cookies/marketing/useRefCode";
import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useSite from "@casino/legacy/client/hooks/useSite";
import internationalCallingCodes from "@casino/legacyUi/form/FormSelect/InternationalCallingCodes";
import FRIENDREF_COOKIE from "@workspace/casino_config/cookies/FRIENDREF_COOKIE";
import REF_AFF from "@workspace/casino_config/cookies/REF_AFF";
import { useRegisterMutation } from "@workspace/casino_core/mutations/RegisterMutation.client";
import { getCookie } from "@workspace/cookies/browser";
import { useState } from "react";
import type FormValues from "../FormValues";
import useHandleRegisterResponse from "./useHandleRegisterResponse";

const useHandleRegister = (isCaptchaRequired: boolean) => {
  const { site } = useSite();
  const { code: language } = useLanguage();
  const [loading, setLoading] = useState(false);
  const refAff = getCookie(REF_AFF);
  const friendRef = getCookie(FRIENDREF_COOKIE);
  const cid = getCookie("cid");
  const refCode = useRefCode();
  const [registerUser] = useRegisterMutation();
  const { handleFormCaptcha } = useHandleFormCaptcha(isCaptchaRequired, true);

  const { handleRegisterResponse, loading: registerResponseLoading } =
    useHandleRegisterResponse();

  type Args = Omit<FormValues, "dateOfBirth"> & { dateOfBirth: number };

  const handleRegister = async (values: Args) => {
    setLoading(true);

    const {
      username,
      email,
      password,
      offers,
      dateOfBirth,
      offersCall,
      offersSms,
      captcha,
    } = values;
    const { captchaToken, captchaVersion } = await handleFormCaptcha(captcha);
    const { phone, countryCode = "XX" } = values;
    const countryCallingCode =
      internationalCallingCodes?.[countryCode]?.code?.toString();
    const { data } = await registerUser({
      input: {
        site,
        username,
        email,
        dateOfBirth,
        password,
        offers,
        offersCall,
        offersSms,
        captcha: captchaToken,
        captchaVersion,
        cid,
        refAff,
        friendRef,
        refCode,
        language,
        phone:
          countryCallingCode && phone
            ? `+${countryCallingCode}${phone}`
            : phone,
      },
    });
    setLoading(false);
    return handleRegisterResponse(data?.userManagementRegisterAsUser, {
      captchaVersion,
      method: "Email",
      offers: offers ?? false,
    });
  };

  return {
    loading: loading || registerResponseLoading,
    handleRegister,
    handleRegisterResponse,
  };
};

export default useHandleRegister;
